import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import SpeedOutlined from '@mui/icons-material/SpeedOutlined';

import { NavItemType } from 'types';

const control: NavItemType = {
    id: '',
    title: <></>,
    icon: SpeedOutlined,
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'PANEL_DE_CONTROL',
            type: 'item',
            url: '/dashboard',
            icon: DashboardOutlined
        }
    ]
};

export default control;
